export const FRAME_COLOR = {
  application: "#d0d1f5",
  system: "#ffe0e4",
  unknown: "#f3f4f6",
};

export const FRAME_TYPES = [
  { label: "Application Frame", color: "bg-frame-application" },
  { label: "System Frame", color: "bg-frame-system" },
];
